import {Component} from "@angular/core";
import {OrderReadyQualifierSearchModel} from "../order-ready-qualifier-search-model.service";
import {OrderReadyQualifierEntityModel} from "../order-ready-qualifier-entity-model.service";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-order-ready-qualifier-search-page",
    templateUrl: "./order-ready-qualifier-search-page.component.html",
    providers: [provideSearchModel(OrderReadyQualifierSearchModel), provideEntityModel(OrderReadyQualifierEntityModel)]
})
export class OrderReadyQualifierSearchPageComponent extends AbstractSearchPage {
    constructor(private searchModel: OrderReadyQualifierSearchModel) {
        super();
    }
}
